export default __webpack_public_path__ + "static/media/gallery-wip-emitter-body_03.7d04a361.jpg";